var _path, _path2, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPet = function SvgPet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44444 17V17C3.54213 17 2 15.4579 2 13.5556V11C2 6.58172 5.58172 3 10 3H14C18.4183 3 22 6.58172 22 11V13.5556C22 15.4579 20.4579 17 18.5556 17V17",
    stroke: "#282828",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9V14C5 17.866 8.13401 21 12 21V21C15.866 21 19 17.866 19 14V9",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 11,
    r: 1,
    fill: "#282828"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 11,
    r: 1,
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2999 16.9116C12.1183 17.0295 11.8817 17.0295 11.7001 16.9116L10.2418 15.9647C9.79665 15.6757 10.0067 15 10.5417 15L13.4583 15C13.9933 15 14.2033 15.6757 13.7582 15.9647L12.2999 16.9116Z",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 1.5
  })));
};
export default SvgPet;